import { ServicesDataProvider } from '../../services/context/ServicesContext';
import CreateRequest from './CreateRequest';

export default function CreateRequestPage() {
  return (
    <ServicesDataProvider>
      <CreateRequest />
    </ServicesDataProvider>
  );
}